import React from "react";

import { Table, Typography, Alert } from "antd";

const { Text, Title } = Typography;

export const expandedPurchaseOrderTask = (record, task) => {
    let baseUnit = task.base_unit ? task.base_unit?.name : " ";

    const payables = task.payables.filter((e) => e.subtotal_value > 0 || e.rectification);

    const columns = (unit) => {
        return [
            {
                title: "Description",
                dataIndex: "catlog_value_name",
                key: "type",
                idth: 50,
                render: (catlogValue, record) => {
                    if (catlogValue) {
                        return catlogValue;
                    }

                    if (record.rectification) {
                        return "Rectification";
                    }

                    return unit;
                },
            },
            {
                title: "#",
                dataIndex: "count",
                key: "count",
                align: "right",
                width: 50,
                render: (count, record) => (record.percent ? Number.parseInt(count) : count),
            },
            {
                title: "Rate",
                dataIndex: "rate_value",
                key: "rateValue",
                align: "right",
                width: 150,
                render: (rateValue, record) => (record.percent ? `${rateValue} (${record.percent}%)` : rateValue),
            },
            {
                title: "Subtotal",
                dataIndex: "subtotal_value",
                key: "subtotalValue",
                align: "right",
                width: 150,
            },
        ];
    };

    const uncompensatedAmount = Number.parseFloat(task.total_to_pay_value - task.balance_vendor).toFixed(4);
    const uncompensatedStatus =
        uncompensatedAmount > 0.00001 ? "danger" : uncompensatedAmount < -0.00001 ? "success" : "";

    return (
        <Table
            columns={columns(baseUnit)}
            rowKey={(record) => record.id}
            dataSource={payables || []}
            pagination={false}
            title={() => <Title level={5}>Task Payables</Title>}
            summary={() => {
                return (
                    <>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Total</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>
                                    {task.total_to_pay_value} {task.total_to_pay_type}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Compensated</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text type="danger">
                                    ({task.balance_vendor} {task.total_to_pay_type})
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Uncompensated</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text type={uncompensatedStatus}>
                                    {uncompensatedAmount} {task.total_to_pay_type}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </>
                );
            }}
        />
    );
};
